import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core';
import { UNSAVED_CHANGES_LEAVE_MESSAGE } from '../utils/messages';

export default function IndietroButtonColorFul(props) {
  let theme = useTheme();
  let history = useHistory();
  return (
    <Button
      onClick={() => {
        if (props.alert === true) {
          var r = window.confirm(UNSAVED_CHANGES_LEAVE_MESSAGE);
          if (r === true) {
            props.onConfirmedNavigate?.();
            history.goBack();
          }
        } else {
          history.goBack();
        }
      }}
      variant="contained"
      className="float-right"
      size="medium"
      disabled={props.isDisabled}
      style={{
        color: props.isDisabled
          ? theme.palette.text.disabled
          : theme.palette.text.main,
        margin: '10px',
        backgroundColor: props.isDisabled
          ? theme.palette.disabled.main
          : props.secondaryButton
            ? theme.palette.secondary.main
            : theme.palette.primary.main,
      }}
    >
      {props.label === null || props.label === undefined
        ? 'Indietro'
        : props.label}
    </Button>
  );
}

IndietroButtonColorFul.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  alert: PropTypes.bool,
  label: PropTypes.string,
  onConfirmedNavigate: PropTypes.func,
};
